<template>
  <teleport to="#drawer">
    <div
      v-if="renderShader"
      :id="containerId"
      :key="containerId"
      class="drawer-shader fixed-cover"
      :class="{ active: opened }"
      @click="opened = false"></div>
    <div
      v-bind="$attrs"
      class="drawer"
      :class="{
        active: opened,
        ['drawer--' + location]: true,
        ...drawerThemeClass,
      }">
      <slot name="header" v-bind="{ drawer: this }">
        <div
          v-if="hasHeaderContent"
          class="drawer-header flex-between flex-middle margin-xl-bottom"
          :class="{
            'flex-row-reverse': location === 'inline-end',
          }">
          <slot name="header-content" v-bind="{ drawer: this }">
            <h3
              v-if="title || $slots['header-title']"
              class="margin-remove text-center"
              style="flex: 100%">
              <slot name="header-title" v-bind="{ drawer: this }">
                <span>{{ translateTitleCase(title) }}</span>
              </slot>
            </h3>
          </slot>
          <icon
            v-if="showCloseIcon"
            icon="x"
            class="cursor-pointer drawer__close"
            :size="1.75"
            @click="opened = false" />
        </div>
      </slot>
      <div
        v-if="!hasHeaderContent && showCloseIcon"
        class="mini-header"
        :class="{
          'flex-row': location === 'inline-end',
          'flex-row-reverse': location !== 'inline-end',
        }">
        <slot name="close-icon" v-bind="{ drawer: this }">
          <icon
            icon="x"
            class="cursor-pointer drawer__close drawer__close--absolute"
            :size="1.75"
            @click="opened = false" />
        </slot>

      </div>

      <slot name="drawer-content" v-bind="{ drawer: this }">
        <div class="drawer-content">
          <slot v-bind="{ drawer: this }"></slot>
        </div>
      </slot>
    </div>
  </teleport>
</template>

<script>
import drawer from "@/client/extensions/mixins/baseComponents/etc/drawer";

export default {
  mixins: [drawer],
  props: {
    theme: {
      type: [String, Boolean],
      default: false,
    },
    themeMap: {
      type: Object,
      default: () => ({
        default: "gray-1",
        lead: "gray-1",
        "lead-2": "gray-1",
        alt: "gray-1",
        alt2: "gray-1",
        inverse: "gray-1",
        bg: "inverse",
        "bg-4": "inverse",
        "bg-5": "inverse",
        "comp-lead": "gray-1",
        "comp-lead-2": "gray-1",
        "comp-alt": "gray-1",
        "comp-alt-2": "gray-1",
        "gray-1": "gray-5",
        "gray-2": "gray-5",
        gray: "inverse",
        "gray-3": "inverse",
        "gray-4": "gray-1",
        "gray-5": "bg",
        success: "gray-1",
        "success-inverse": "success",
        warning: "gray-1",
        "warning-inverse": "success",
        danger: "gray-1",
        "danger-inverse": "success",
        error: "gray-1",
        "error-inverse": "success",
      }),
    },
  },
  computed: {
    drawerThemeClass() {
      if (!this.theme) {
        return {};
      }

      let inverseTheme = this.themeMap?.[this.theme];

      return {
        [`bg-${this.theme}`]: true,
        [`c-${inverseTheme}`]: true,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  --drawer-offset: v-bind(calculatedOffset);
  --drawer-width: v-bind(widthCssValue);
}
</style>
